import { ShortcutBase } from './ShortcutBase';
import { ScenarioStatisticQuery } from '../../ScenarioStatisticQuery';
import { ShortcutType, IQueryShortcutOptions, TRootOptionsShortcutFnReturn } from '../../../models/query/scenarioStatistics/shortcuts';
import { ScenarioStatisticShortcut } from '../../../models/query/scenarioStatistics';

export class FundsShortcut extends ShortcutBase {
	constructor(scenarioStatisticQuery: ScenarioStatisticQuery) {
		super(ScenarioStatisticShortcut.funds, ShortcutType.rootOptions, scenarioStatisticQuery);
	}
	getRootOptions(shortcutOptions: IQueryShortcutOptions) {
		const { options = {}, periods = {}, portfolios = {}, portfolioEntities = {} } = shortcutOptions;
		const response: TRootOptionsShortcutFnReturn = this.scenarioStatisticQuery.shortcuts.portfolios.getRootOptions(
			{
				...shortcutOptions,
				options: {
					portfolios: {
						key: 'funds',
						options: {
							funds: {
								...portfolioEntities,
								...(options.funds || {}),
							},
						},
					},
				},
			},
		);
		return response;
	}
}